import React from 'react'

import { FormRating } from '../FormRating'

export const FeedbackForm = props => {
  const { classes } = props

  return (
    <form action="">
      <FormRating
        isError={props.isError}
        setIsError={props.setIsError}
        handleChange={props.handleChange}
      />
      <textarea
        onChange={e => props.handleChange('comment', e.target.value)}
        className={classes.textarea}
        placeholder={props.commentInputPlaceholder}
      />
    </form>
  )
}
